import { MainAction } from './models'

export const submitB2bRequest: MainAction<any> =
  (body, callback) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    try {
      const res = await api.post(`/company/volunteer`, body)
      callback('succeed', res.data)
    } catch (err) {
      callback('failed', err)
    }
  }
